export default "__VITE_ASSET__BWYxZ2r3__"